/**
 * "Download Cart" CSV — cart page + WeTheme right-drawer cart.
 * Buttons: #download_csv_btn1 (primary), optional #download_csv_btn2.
 * Status: #generate_link when present.
 *
 * Uses document-level click capture so Vue x-template clones in the
 * right drawer still work (DOMContentLoaded bind never sees those nodes).
 */
(function () {
  var isDownloading = false;

  function setStatus(el, msg, isErr) {
    if (!el) return;
    el.textContent = msg || '';
    if (msg) {
      el.style.display = 'block';
    } else {
      el.style.display = 'none';
    }
    if (typeof isErr === 'boolean') {
      el.style.color = isErr ? '#d32f2f' : '';
      el.classList.toggle('error', isErr);
      el.classList.toggle('success', !isErr && !!msg);
    }
  }

  function statusNear(btn) {
    var scope = btn.closest('#CartContainer, form.cart, form.ajaxcart, .ajaxcart__footer, .cart__footer, .grid__item');
    if (scope) {
      var local = scope.querySelector('#generate_link');
      if (local) return local;
    }
    return document.getElementById('generate_link');
  }

  function runDownload(statusEl) {
    if (isDownloading) return;
    isDownloading = true;
    setStatus(statusEl, 'Preparing…', false);

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart fetch failed');
        return r.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          setStatus(statusEl, 'Cart is empty', true);
          return;
        }
        setStatus(statusEl, 'Generating…', false);
        var rows = [['Item Number', 'Product', 'Quantity', 'Price', 'ExtendedPrice']];
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          var sku = item.sku ? String(item.sku) : 'N/A';
          var title = (item.title || 'Unknown').replace(/,/g, ' | ');
          var qty = item.quantity || 0;
          var price = (item.price || 0) / 100;
          var ext = (qty * price).toFixed(2);
          price = price.toFixed(2);
          rows.push([sku, title, qty, price, ext]);
        }
        var csv = rows
          .map(function (row) {
            return row
              .map(function (c) {
                return '"' + String(c).replace(/"/g, '""') + '"';
              })
              .join(',');
          })
          .join('\n');
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'CLNF-Shopping-Cart.csv';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        setStatus(statusEl, 'Downloaded', false);
        setTimeout(function () {
          setStatus(statusEl, '', false);
        }, 2500);
      })
      .catch(function () {
        setStatus(statusEl, 'Error — try again', true);
      })
      .finally(function () {
        isDownloading = false;
      });
  }

  function isDownloadBtn(el) {
    if (!el || el.nodeType !== 1) return null;
    if (el.id === 'download_csv_btn1' || el.id === 'download_csv_btn2') return el;
    return el.closest ? el.closest('#download_csv_btn1, #download_csv_btn2') : null;
  }

  function onClick(e) {
    var btn = isDownloadBtn(e.target);
    if (!btn) return;
    e.preventDefault();
    runDownload(statusNear(btn));
  }

  if (!window.__clnfCartCsvDelegationBound) {
    window.__clnfCartCsvDelegationBound = true;
    document.addEventListener('click', onClick, true);
  }
})();
